import { LotStatus } from "@/enums/LotStatus";
import { StageInterface } from "@/v2/types/StageInterface";

export const getAllLotsForReports = (
  stages: StageInterface[],
  statuses?: LotStatus[],
  stageId?: string
) => {
  if (!stages || !Array.isArray(stages) || stages.length === 0) {
    return [];
  }

  const filteredStages =
    stageId && stageId !== "all"
      ? stages.filter((stage) => stage._id === stageId)
      : stages;

  return filteredStages.flatMap((stage) =>
    statuses
      ? stage.lots.filter((lot) => statuses.includes(lot.status))
      : stage.lots
  );
};
